import {
	markProOnboardingSeen,
} from './Api';

export const ONBOARDING_REFRESH_EVENT = 'bidzbase:onboarding-refresh';
export const PRO_ONBOARDING_REFRESH_EVENT = 'bidzbase:pro-onboarding-refresh';

export const refreshOnboardingChecklist = () => {
	window.dispatchEvent(new Event(ONBOARDING_REFRESH_EVENT));
};

export const refreshProOnboardingChecklist = () => {
	window.dispatchEvent(new Event(PRO_ONBOARDING_REFRESH_EVENT));
};

/** Mark a Pro tour step seen (schedule / time / analytics). Fire-and-forget. */
export const markProOnboardingStepSeen = (stepId) => {
	markProOnboardingSeen(stepId)
		.then(() => {
			refreshProOnboardingChecklist();
		})
		.catch((error) => {
			console.debug('Pro onboarding mark-seen failed:', stepId, error);
		});
};
